module.exports = __webpack_public_path__ + "static/media/Leftarrow.86ba0531.svg";